import { keyframes } from '@emotion/react';
import { css } from '@recruit-robin/robin-theme/web-styles';

/** Per-block reveal. */
const stagIn = keyframes`
  from { opacity: 0; transform: translateY(7px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/** Question change. */
const qFade = keyframes`
  from { opacity: 0; transform: translateY(5px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const STAGGER_STEPS = 6;

/**
 * Progressive reveal on first paint, so a slow screen resolves in reading order instead
 * of appearing all at once. 40ms apart.
 *
 * Applied **once per visit** — never replayed on a language switch or on returning from
 * an edit, which is why the caller latches it rather than passing it every render.
 */
export const staggerCss = css`
  & > * {
    animation: ${stagIn} 0.34s cubic-bezier(0.22, 0.61, 0.36, 1) both;
  }

  ${Array.from(
    { length: STAGGER_STEPS },
    (_, index) => `& > *:nth-child(${index + 1}) { animation-delay: ${0.02 + index * 0.04}s; }`,
  ).join('\n')}
`;

/**
 * The question screen deliberately does **not** stagger. It is a tap rhythm — the options
 * are the targets, and queuing them in would delay every tap. One short fade signals the
 * change instead: the question resolves, then the options 80ms later, in reading order.
 */
export const questionFadeCss = css`
  animation: ${qFade} 0.2s ease both;
`;

export const optionsFadeCss = css`
  animation: ${qFade} 0.2s ease 0.08s both;
`;
